import type { Span as SentrySpanType, SpanAttributeValue as SentrySpanAttributeValue } from '@sentry/core';

/**
 * SentrySpan
 */
export class SentrySpan {
  public enabled = false;

  public instance: SentrySpanType;

  /**
   *
   * @param {SentrySpanType} spanInstance
   * @param {boolean} enabled
   */
  constructor(spanInstance?: SentrySpanType, enabled = false) {
    this.enabled = enabled;

    if (this.enabled && spanInstance) {
      this.instance = spanInstance;
    }
  }

  /**
   * end
   *
   * @returns {void}
   */
  public end(): void {
    if (this.enabled && this.instance) {
      this.instance.end();
    }
  }

  /**
   * setAttribute
   *
   * @param {string} name
   * @param {SentrySpanAttributeValue} value
   * @returns {void}
   */
  public setAttribute(name: string, value: SentrySpanAttributeValue): void {
    if (this.enabled && this.instance) {
      this.instance.setAttribute(name, value);
    }
  }
}
